const getDefaultState = () => {
  return {
    applyLoading: false,
    viewLoading: false,
    isVerified: false,
    dynamicDataRes: {},
    // 每个组件的配置
    componentOptions: {},
    // 组件缓存状态
    cacheComponent:{},
    modifiedTableHeaderData:{},
    currentTablePosition: {},
    currentTempIndex: null,
  };
};
const state = getDefaultState();

const mutations = {
  SET_APPLY_LOADING: (state, loading) => {
    state.applyLoading = loading;
  },
  SET_VIEW_LOADING: (state, loading) => {
    state.viewLoading = loading;
  },
  SET_IS_VERIFIED: (state, isVerified) => {
    state.isVerified = isVerified;
  },
  SET_DYNAMIC_DATA_RES: (state, dynamicDataRes) => {
    state.dynamicDataRes = dynamicDataRes;
  },
  SET_COM_OPTIONS_SET_UP: (state, currentComponentOptions) => {
    const index = state.currentTempIndex
    const componentOptions = {...state.componentOptions}
    componentOptions[index] = {...currentComponentOptions}
    state.componentOptions = { ... componentOptions }
    // console.log(state.componentOptions,index, 'state-componentOptions');
  },
  SET_COM_CACHE: (state, currentCacheComponent) => {
    // debugger;
    const index = state.currentTempIndex
    const cacheComponent = {...state.cacheComponent}
    cacheComponent[index] = {...currentCacheComponent}
    state.cacheComponent = { ... cacheComponent }
    console.log(state.cacheComponent,index, '-*---cacheComponent');
  },
  SET_CURRENT_TABLE_POSITION_RES: (state, currentTablePosition) => {
    state.currentTablePosition = currentTablePosition;
  },
  SET_CURRENT_TEMP_INDEX: (state, currentTempIndex) => {
    state.currentTempIndex = currentTempIndex;
  },
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
